import { IconButton, Typography, Box, useTheme } from "@mui/material";
import React from "react";
import { Chat } from "@mui/icons-material";
import useResponsive from "../../hooks/useResponsive";
export type IRemarksCardProps = {
  handleOpenPMRemarkDialog: () => void;
  handleOpenDialog: () => void;
  pmRemarkStatus: boolean | null | undefined;
  handleOpenDailyRemarkDialog: () => void;
  pmDailyRemarkStatus: boolean | null | undefined;
};

const RemarksCard: React.FC<IRemarksCardProps> = ({
  handleOpenPMRemarkDialog,
  handleOpenDialog,
  pmRemarkStatus,
  handleOpenDailyRemarkDialog,
  pmDailyRemarkStatus
}) => {
  const theme = useTheme();
  const { isDesktop, isMobile } = useResponsive();
  return (
    <Box
      sx={{
        display: "flex",
        width: "90%",
        flexDirection: "row",
        mt: !isDesktop ? "30px" : "25px",
      }}
    >
      {/* PM section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          // mb: 1,
          flex: 1,
        }}
      >
        <Typography
          fontFamily={"Nunito Sans SemiBold"}
          sx={{
            color: theme.palette.primary.main,
            mr: 1,
            width: "100",
            fontSize: "15px",
          }}
        >
          {isMobile ? "PM" : "Opmerkingen PM"}
        </Typography>
        <IconButton onClick={handleOpenPMRemarkDialog}>
          <Chat
            fontSize="medium"
            sx={{
              color: pmRemarkStatus ? "red" : theme.palette.primary.main,
            }}
          />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          flex: 1,
        }}
      >
        <Typography
          fontFamily={"Nunito Sans SemiBold"}
          sx={{
            color: theme.palette.primary.main,
            mr: 1,
            fontSize: "15px",
            whiteSpace: "nowrap",
          }}
        >
          {isMobile ? "Werknemer" : "Opmerkingen Werknemer"}
        </Typography>
        <IconButton onClick={() => handleOpenDialog()}>
          <Chat fontSize="medium" sx={{ color: theme.palette.primary.main }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          flex: 1,
        }}
      >
        <Typography
          fontFamily={"Nunito Sans SemiBold"}
          sx={{
            color: theme.palette.primary.main,
            mr: 1,
            fontSize: "15px",
            whiteSpace: "nowrap",
          }}
        >
          {isMobile ? "Dag" : "Opmerkingen Dag"}
        </Typography>
        <IconButton onClick={() => handleOpenDailyRemarkDialog()}>
          <Chat fontSize="medium" sx={{ color: pmDailyRemarkStatus ? "red" : theme.palette.primary.main }} />
        </IconButton>
      </Box>

    </Box>
  );
};

export { RemarksCard };
